"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.latviaTranslations = void 0;
var _types = require("../../../types");
const latviaTranslations = exports.latviaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Atvainojiet!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Atpakaļ',
  [_types.ErrorPageTranslationKey.text]: 'Šī lapa šobrīd nav pieejama',
  [_types.ErrorPageTranslationKey.notFound]: 'Diemžēl, šis lapas saturs šobrīd nav pieejams',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Lapa, kuru mēģināt sasniegt, ir ierobežota, un netika izpildīti visi kritēriji.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Lūdzu, sazinieties ar Oriflame atbalsta komandu pa e-pastu:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Pieprasītais URL tika noraidīts!'
};
